import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ProgressSteps from '../components/ToolBox/ProgressSteps';
import Step1_SelectClinic from '../components/ToolBox/ServiceDoctorQAGenerator/Step1_SelectClinic';
import Step2_Generate from '../components/ToolBox/ServiceDoctorQAGenerator/Step2_Generate';
import Step3_Preview from '../components/ToolBox/ServiceDoctorQAGenerator/Step3_Preview';
import Step4_Confirm from '../components/ToolBox/ServiceDoctorQAGenerator/Step4_Confirm';

const ServiceDoctorQAGenerator = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [clinicId, setClinicId] = useState('');
  const [qaItems, setQAItems] = useState([]);
  const [summary, setSummary] = useState(null);
  const [error, setError] = useState('');

  const handleStep1Next = (data) => {
    setClinicId(data.clinicId);
    setError('');
    setCurrentStep(1);
  };

  const handleStep2Next = (data) => {
    setQAItems(data.qaItems);
    setError('');
    setCurrentStep(2);
  };

  const handleStep3Next = (data) => {
    setQAItems(data.qaItems);
    setError('');
    setCurrentStep(3);
  };

  const handleStep4Complete = (data) => {
    setSummary(data);
    setError('');
  };

  const handleRestart = () => {
    setCurrentStep(0);
    setClinicId('');
    setQAItems([]);
    setSummary(null);
    setError('');
  };

  const goToStep = (step) => {
    setCurrentStep(step);
    setError('');
  };

  return (
    <div className="max-w-6xl mx-auto p-6">
      <div className="bg-white rounded-lg shadow-lg p-8">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900">Service-to-Doctor QA Generator</h1>
          <p className="text-gray-600">
            Generate QA from doctors&apos; service_provided. Select clinic, build service mapping, preview,
            edit, set tags, then import.
          </p>
        </div>

        <ProgressSteps currentStep={currentStep} totalSteps={4} />

        {currentStep === 0 && (
          <Step1_SelectClinic onNext={handleStep1Next} error={error} setError={setError} />
        )}

        {currentStep === 1 && clinicId && (
          <Step2_Generate
            clinicId={clinicId}
            onBack={() => goToStep(0)}
            onNext={handleStep2Next}
            error={error}
            setError={setError}
          />
        )}

        {currentStep === 2 && clinicId && qaItems.length > 0 && (
          <Step3_Preview
            clinicId={clinicId}
            qaItems={qaItems}
            onBack={() => goToStep(1)}
            onNext={handleStep3Next}
            error={error}
            setError={setError}
          />
        )}

        {currentStep === 3 && !summary && clinicId && qaItems.length > 0 && (
          <Step4_Confirm
            clinicId={clinicId}
            qaItems={qaItems}
            onBack={() => goToStep(2)}
            onComplete={handleStep4Complete}
            error={error}
            setError={setError}
          />
        )}

        {currentStep === 3 && summary && (
          <div className="space-y-6">
            <div className="text-center">
              <h2 className="text-2xl font-bold text-gray-900 mb-2">Complete</h2>
              <p className="text-gray-600">
                {summary.success
                  ? 'QA items imported successfully.'
                  : 'Import completed with errors.'}
              </p>
            </div>
            {summary.success && (
              <Link
                to={`/clinics/${clinicId}#qaknowledgebase`}
                className="inline-block px-6 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 font-medium"
              >
                View QA Knowledge Base
              </Link>
            )}
            <div className="flex justify-end">
              <button
                onClick={handleRestart}
                className="px-8 py-3 bg-gray-600 text-white rounded-md hover:bg-gray-700 font-medium"
              >
                Start New
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ServiceDoctorQAGenerator;
